// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"_2jJC-_TxoZwDS8Q7FM4cTm","tick":"_2VOevuZhhiDKKgMy-D1nrM","square":"_1qw-L18zU6Dv39c_80t7rp","checked":"_2c2aYms54te6CcZ5U6MZEG","unchecked":"_1j0uCOrnIE7FRG4DSIwj-v"};